import { render, staticRenderFns } from "./NewSelectWrapper.vue?vue&type=template&id=2c6fc8f6&scoped=true&"
import script from "./NewSelectWrapper.vue?vue&type=script&lang=js&"
export * from "./NewSelectWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NewSelectWrapper.vue?vue&type=style&index=0&lang=less&"
import style1 from "./NewSelectWrapper.vue?vue&type=style&index=1&id=2c6fc8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6fc8f6",
  null
  
)

export default component.exports